import { matchPath } from 'react-router-dom';
import type { ResolvedRoute, RouteDefinition } from './types';

let routeDefinitions: RouteDefinition[] = [];

export const setProtectedRouteDefinitions = (definitions: RouteDefinition[]): void => {
  routeDefinitions = definitions;
};

export const getProtectedRouteDefinitions = (): RouteDefinition[] => routeDefinitions;

export const resolveRouteEntry = (pathname: string): ResolvedRoute | null => {
  for (const definition of routeDefinitions) {
    if (definition.redirectTo) continue;

    const match = matchPath({ path: definition.path, end: true }, pathname);
    if (match) {
      return { definition, params: match.params };
    }
  }
  return null;
};

export const getRedirectForPath = (pathname: string): string | null => {
  for (const definition of routeDefinitions) {
    if (!definition.redirectTo) continue;

    const match = matchPath({ path: definition.path, end: true }, pathname);
    if (match) {
      return definition.redirectTo;
    }
  }
  return null;
};

export const shouldKeepAliveRoute = (pathname: string): boolean => {
  const resolved = resolveRouteEntry(pathname);
  if (!resolved) return false;
  return resolved.definition.keepAlive !== false;
};
